import { useRef } from 'react';
import { MovieWatchParamsFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useCurrentAudioTrack } from '@/scenarios/legacy-player/hooks/useCurrentAudioTrack';
import { useCurrentTextTrack } from '@/scenarios/legacy-player/hooks/useCurrentTextTrack';

export const useReplaceWatchParams: (
    watchParams: MovieWatchParamsFragment['watchParams'] | undefined
) => MovieWatchParamsFragment['watchParams'] | undefined = (watchParams) => {
    const currentAudioTrack = useCurrentAudioTrack();
    const currentTextTrack = useCurrentTextTrack();

    const watchParamsRef = useRef<MovieWatchParamsFragment['watchParams'] | undefined>({
        audioLanguage: currentAudioTrack?.lang || null,
        subtitleLanguage: currentTextTrack?.lang || null,
    });

    if (watchParams?.audioLanguage || watchParams?.subtitleLanguage) {
        return watchParams;
    }

    return watchParamsRef.current;
};
